import { Button, Drawer } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ReactToPrint from 'react-to-print'
import dayjs from 'dayjs'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faPrint, faXmark } from '@fortawesome/free-solid-svg-icons'
import { PrinterOutlined } from '@ant-design/icons'

import { verificarSeAlgoEstaPreenchido, verificarSeHouveAlteracoes } from './meta'
import { DetalhesClientes } from './components/detalhesCliente'
import { Analises } from './components/análises'
import { TalhaoItens } from '../../../../../../services/Talhao'
import { LabAnaliseItens } from '../../../../../../services/LabAnalise'
import { GeoPointFeature } from './components/análises/components/headerAnalises/components/modalNovaAnalise'
import { ClienteItensTypes } from '../../../../../../services/Cliente'
import { SafraItens } from '../../../../../../services/Safra'
import { RepresentanteLegalItens } from '../../../../../../services/RepresentanteLegal'
import { PropsAnalisesCadastradas, PropsTiposAnalise } from '../..'
import Print from '../../../../../../Components/ordemLaboratorio/printOS'
import { buscaCidade } from '../../../../../../services/Afins'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { Item__EquipeCliente } from '../../../../../../services/Equipe/GET'
import { DrawerCustom } from '../../../../../../Components/CustomUi/Drawer'
import { ConfirmarFecharGaveta } from '../../../../patrimonioNovo/cadastro/components/confirmarFecharGaveta'

interface PropsFormOs {
  abrirGaveta: boolean
  fecharGaveta: Function
  update: number
  permissions: ItensPerUserLogged
  salvarOsColeta: Function
  loadingSalvarOsColeta: boolean
  loading_formulario: boolean
  dados_cliente: ClienteItensTypes
  data_representante: RepresentanteLegalItens[]
  status_atual: string
  setStatus_atual: React.Dispatch<React.SetStateAction<string>>
  setStatus_atual_id: React.Dispatch<React.SetStateAction<number>>
  data_da_os: string
  setData_da_os: React.Dispatch<React.SetStateAction<string>>
  outros_solicitantes: string
  setOutros_solicitantes: React.Dispatch<React.SetStateAction<string>>
  propriedade: string
  setPropriedade: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_id: React.Dispatch<React.SetStateAction<number>>
  talhao: string
  setTalhao: React.Dispatch<React.SetStateAction<string>>
  setTalhao_id: React.Dispatch<React.SetStateAction<number>>
  matricula: string
  area_propriedade: string
  laboratorio: string
  setLaboratorio: React.Dispatch<React.SetStateAction<string>>
  setLaboratorio_id: React.Dispatch<React.SetStateAction<number>>
  safra_consultoria: string
  setSafra_consultoria: React.Dispatch<React.SetStateAction<string>>
  setSafra_consultoria_id: React.Dispatch<React.SetStateAction<number>>
  area_amostra_laudo: string
  setArea_amostra_laudo: React.Dispatch<React.SetStateAction<string>>
  responsaveis_selecionados: { descr: string; id: number; key?: number }[]
  setResponsaveis_selecionados: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  coleta_liberada: string
  setColeta_liberada: React.Dispatch<React.SetStateAction<string>>
  coletada_em: string
  setColetada_em: React.Dispatch<React.SetStateAction<string>>
  representante_selecionado: string
  setRepresentante_selecionado: React.Dispatch<React.SetStateAction<string>>
  setRepresentante_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  open_loading_analise_lab: boolean
  setOpen_loading_analise_lab: React.Dispatch<React.SetStateAction<boolean>>
  grupoAnalises: LabAnaliseItens[]
  setGrupoAnalises: React.Dispatch<React.SetStateAction<LabAnaliseItens[]>>
  tipo_de_analise: string
  setTipo_de_analise: React.Dispatch<React.SetStateAction<string>>
  dataPropriedades: { nome: string; cod: number; area?: string; matricula?: string; cod_cidade?: number }[]
  dataTalhoes: TalhaoItens[]
  data_laboratorio: any[]
  data_safra_consultoria: SafraItens[]
  data_equipe: Item__EquipeCliente[]
  data_tipos_analise: PropsTiposAnalise[]
  buscarTalhaoPropriedade: Function
  propriedade_id: number
  talhao_id: number
  laboratorio_id: number
  data_osColeta_editar: any

  //ANALISES
  setLoadingShape: React.Dispatch<React.SetStateAction<boolean>>
  malha: any
  setMalha: React.Dispatch<React.SetStateAction<any[]>>
  malhaShp: any[]
  setMalhaShp: React.Dispatch<React.SetStateAction<any[]>>
  tipo_analise_selecionada: string
  setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>
  tipo_analise_selecionada_id: number
  setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  pontos_selecionados: GeoPointFeature[]
  setPontos_selecionados: React.Dispatch<React.SetStateAction<GeoPointFeature[]>>
  pontos_selecionados_adicionados: PropsAnalisesCadastradas[]
  setPontos_selecionados_adicionados: React.Dispatch<
    React.SetStateAction<
      { pontos_selecionados: GeoPointFeature[]; profundidade: string; analise_nome: string }[]
    >
  >
  setAnalises_nao_encontradas: React.Dispatch<React.SetStateAction<any[]>>
  setValores_analises_editados: React.Dispatch<React.SetStateAction<any[]>>
  setOpen_modal_confirm_lab: React.Dispatch<React.SetStateAction<boolean>>
  analises: any[]
  setAnalises: React.Dispatch<React.SetStateAction<any[]>>
  pontosTotalMalha: number
  setPontosTotalMalha: React.Dispatch<React.SetStateAction<number>>
  talhaoKml: any[]
  setTalhaoKml: React.Dispatch<React.SetStateAction<any[]>>
  talhaoArea: string
  setTalhaoArea: React.Dispatch<React.SetStateAction<string>>
}

export const FormularioOsColeta: React.FC<PropsFormOs> = ({
  abrirGaveta,
  fecharGaveta,
  update,
  permissions,
  salvarOsColeta,
  loadingSalvarOsColeta,
  loading_formulario,
  dados_cliente,
  data_representante,
  status_atual,
  setStatus_atual,
  setStatus_atual_id,
  data_da_os,
  setData_da_os,
  outros_solicitantes,
  setOutros_solicitantes,
  propriedade,
  setPropriedade,
  setPropriedade_id,
  talhao,
  setTalhao,
  setTalhao_id,
  matricula,
  area_propriedade,
  laboratorio,
  setLaboratorio,
  setLaboratorio_id,
  safra_consultoria,
  setSafra_consultoria,
  setSafra_consultoria_id,
  area_amostra_laudo,
  setArea_amostra_laudo,
  responsaveis_selecionados,
  setResponsaveis_selecionados,
  coleta_liberada,
  setColeta_liberada,
  coletada_em,
  setColetada_em,
  representante_selecionado,
  setRepresentante_selecionado,
  setRepresentante_selecionado_id,
  grupoAnalises,
  setGrupoAnalises,
  tipo_de_analise,
  setTipo_de_analise,
  open_loading_analise_lab,
  setOpen_loading_analise_lab,
  setAnalises_nao_encontradas,
  setOpen_modal_confirm_lab,
  setValores_analises_editados,
  dataPropriedades,
  dataTalhoes,
  data_laboratorio,
  data_safra_consultoria,
  data_equipe,
  data_tipos_analise,
  buscarTalhaoPropriedade,
  propriedade_id,
  talhao_id,
  laboratorio_id,
  data_osColeta_editar,

  //ANALISES

  setLoadingShape,
  malha,
  setMalha,
  malhaShp,
  setMalhaShp,
  tipo_analise_selecionada,
  setTipo_analise_selecionada,
  tipo_analise_selecionada_id,
  setTipo_analise_selecionada_id,
  pontos_selecionados,
  setPontos_selecionados,
  pontos_selecionados_adicionados,
  setPontos_selecionados_adicionados,
  analises,
  setAnalises,
  pontosTotalMalha,
  setPontosTotalMalha,
  talhaoKml,
  setTalhaoKml,
  talhaoArea,
  setTalhaoArea,
}) => {
  const [openPopover, setOpenPopover] = useState<boolean>(false)
  const dadosOriginaisRef = useRef<any>(null)
  const topRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (openPopover && topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [openPopover])

  // Print states
  const [modalPrint, setModalPrint] = useState<boolean>(false)
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false)
  const [dataPrint, setDataPrint] = useState<any>(null)
  const [dataFinish, setDataFinish] = useState<any>(null)
  const printRef = useRef<HTMLDivElement>(null)

  // Reseta o estado do popover e snapshot ao abrir/fechar a gaveta
  useEffect(() => {
    if (abrirGaveta) {
      setOpenPopover(false)
      dadosOriginaisRef.current = null
    }
  }, [abrirGaveta])

  // Captura o snapshot dos campos DEPOIS que o formulário foi preenchido pelo PreencherDados
  useEffect(() => {
    if (update > 0 && propriedade !== '' && !dadosOriginaisRef.current) {
      // Aguarda o setTimeout do PreencherDados (analises são setadas com delay de 400ms)
      const timer = setTimeout(() => {
        dadosOriginaisRef.current = {
          data_da_os,
          outros_solicitantes,
          propriedade,
          talhao,
          laboratorio,
          safra_consultoria,
          area_amostra_laudo,
          coleta_liberada,
          coletada_em,
          representante_selecionado,
          analises,
          responsaveis_selecionados,
        }
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [update, propriedade, analises])

  function validarAlteracoes() {
    const campos_formulario = {
      data_da_os,
      outros_solicitantes,
      propriedade,
      talhao,
      laboratorio,
      safra_consultoria,
      area_amostra_laudo,
      coleta_liberada,
      coletada_em,
      representante_selecionado,
      analises,
      responsaveis_selecionados,
    }

    // Se o snapshot ainda não foi capturado, fecha direto (dados ainda carregando)
    if (!dadosOriginaisRef.current) {
      fecharGaveta()
      return
    }

    verificarSeHouveAlteracoes(
      dadosOriginaisRef.current,
      campos_formulario,
      setOpenPopover,
      fecharGaveta
    )
  }

  function verificarNovoCadastro() {
    const campos_formulario = {
      data_da_os,
      outros_solicitantes,
      propriedade,
      talhao,
      laboratorio,
      safra_consultoria,
      area_amostra_laudo,
      coleta_liberada,
      coletada_em,
      representante_selecionado,
      analises,
      responsaveis_selecionados,
    }

    verificarSeAlgoEstaPreenchido(campos_formulario, setOpenPopover, fecharGaveta)
  }

  const aoFecharGaveta = update > 0 ? validarAlteracoes : verificarNovoCadastro

  async function handleClickPrint() {
    setLoadingPrint(true)
    try {
      const dados = data_osColeta_editar?.itens?.[0]

      // Monta dataFinish (dados das análises para o componente Print)
      const finishData = {
        cod_laboratorio: laboratorio_id,
        cod_propriedade: propriedade_id,
        cod_talhao: talhao_id,
        responsaveis: responsaveis_selecionados?.map((item) => item?.descr),
        analises: analises?.map((item) => ({
          cod_analises: [{
            cod: item?.cod_analise,
            nome: item?.analise_nome,
            valor: item?.valor,
          }],
          profundidade: item?.profundidade,
          pontos: item?.pontos_selecionados?.map((p) => ({
            NOME: p?.NOME,
            INDICE: p?.INDICE,
            COMENTARIO: '',
          })),
        })),
        malha_de_pontos: malhaShp,
      }

      // Monta dataPrint (dados do cliente/propriedade para o Print)
      const codCidade = dados?.propriedade?.[0]?.cod_cidade
        ?? dataPropriedades?.find((p) => p?.cod === propriedade_id)?.cod_cidade

      let cityUf = ''
      if (codCidade) {
        try {
          const response = await buscaCidade('', '', codCidade)
          const { nome, uf_sigla } = response[0]
          cityUf = `${nome}/${uf_sigla}`
        } catch (e) { }
      }

      const representante = dados?.representante?.[0]
        ?? data_representante?.find((r) => r?.solicitante === representante_selecionado)


      const printData = {
        codOs: dados?.cod ?? 0,
        propriedadeNome: propriedade,
        talhaoNome: talhao,
        cityUf,
        representante: representante ?? {},
        outrosSolicitantes: outros_solicitantes,
        cpf: dados_cliente?.tipo === 'G' ? representante?.cpf : dados_cliente?.cpf_cnpj,
        nome_cliente: dados_cliente?.nome,
        dataColeta: coletada_em ? dayjs(coletada_em).format('DD/MM/YYYY') : null,
        areaAmostra: area_amostra_laudo?.replace(' ha', ''),
      }

      setDataFinish(finishData)
      setDataPrint(printData)
      setModalPrint(true)
    } finally {
      setLoadingPrint(false)
    }
  }

  useEffect(() => {
    if (talhao) {
      setTalhaoArea(String(dataTalhoes?.find((item) => item?.nome === talhao)?.area || 0))
    }
  }, [talhao])

  return (
    <>
      <DrawerCustom
        width={'67%'}
        open={abrirGaveta}
        onClose={aoFecharGaveta}
        paddingBody={10}
        destroyOnClose
        overflow="auto"
        title={update > 0 ? 'Editar O.S ' : 'Cadastrar O.S'}
        childrenFooter={
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '100%' }}>
            <ButtonCustom
              icon={<FontAwesomeIcon icon={faFloppyDisk} />}
              type='primary'
              onClick={salvarOsColeta}
              loading={loadingSalvarOsColeta}
              disabled={permissions?.inclusao === 0 && permissions?.alteracao === 0}
            >
              {update > 0 ? 'Atualizar' : 'Salvar'}
            </ButtonCustom>
            <ButtonCustom
              icon={<FontAwesomeIcon icon={faPrint} />}
              type='secondary'
              onClick={handleClickPrint}
              disabled={analises?.length <= 0}
              loading={loadingPrint}
            >
              Imprimir ordem de coleta
            </ButtonCustom>
          </div>
        }
      >
        <div ref={topRef} style={{ display: 'flex', gap: '5px', alignItems: 'start' }}>
          <ConfirmarFecharGaveta
            title='Você não salvou as alterações!'
            message='Deseja fechar sem salvar? Todas as informações inseridas serão perdidas.'
            openPopover={openPopover}
            setOpenPopover={setOpenPopover}
            onClose={fecharGaveta}
          />
          <DetalhesClientes
            update={update}
            loading_formulario={loading_formulario}
            dados_cliente={dados_cliente}
            data_representante={data_representante}
            status_atual={status_atual}
            setStatus_atual={setStatus_atual}
            setStatus_atual_id={setStatus_atual_id}
            data_da_os={data_da_os}
            setData_da_os={setData_da_os}
            outros_solicitantes={outros_solicitantes}
            setOutros_solicitantes={setOutros_solicitantes}
            propriedade={propriedade}
            setPropriedade={setPropriedade}
            setPropriedade_id={setPropriedade_id}
            talhao={talhao}
            setTalhao={setTalhao}
            setTalhao_id={setTalhao_id}
            matricula={matricula}
            area_propriedade={area_propriedade}
            laboratorio={laboratorio}
            setLaboratorio={setLaboratorio}
            setLaboratorio_id={setLaboratorio_id}
            safra_consultoria={safra_consultoria}
            setSafra_consultoria={setSafra_consultoria}
            setSafra_consultoria_id={setSafra_consultoria_id}
            area_amostra_laudo={area_amostra_laudo}
            setArea_amostra_laudo={setArea_amostra_laudo}
            responsaveis_selecionados={responsaveis_selecionados}
            setResponsaveis_selecionados={setResponsaveis_selecionados}
            coleta_liberada={coleta_liberada}
            setColeta_liberada={setColeta_liberada}
            coletada_em={coletada_em}
            setColetada_em={setColetada_em}
            representante_selecionado={representante_selecionado}
            setRepresentante_selecionado={setRepresentante_selecionado}
            setRepresentante_selecionado_id={setRepresentante_selecionado_id}
            setGrupoAnalises={setGrupoAnalises}
            setOpen_loading_analise_lab={setOpen_loading_analise_lab}
            setAnalises_nao_encontradas={setAnalises_nao_encontradas}
            setOpen_modal_confirm_lab={setOpen_modal_confirm_lab}
            setValores_analises_editados={setValores_analises_editados}
            analises={analises}
            setAnalises={setAnalises}
            tipo_de_analise={tipo_de_analise}
            setTipo_de_analise={setTipo_de_analise}
            dataPropriedades={dataPropriedades}
            dataTalhoes={dataTalhoes}
            data_laboratorio={data_laboratorio}
            data_safra_consultoria={data_safra_consultoria}
            data_equipe={data_equipe}
            data_tipos_analise={data_tipos_analise}
            buscarTalhaoPropriedade={buscarTalhaoPropriedade}
          />
          <Analises
            setLoadingShape={setLoadingShape}
            malha={malha}
            setMalha={setMalha}
            malhaShp={malhaShp}
            setMalhaShp={setMalhaShp}
            talhaoArea={talhaoArea}
            setTalhaoArea={setTalhaoArea}
            talhaoKml={talhaoKml}
            setTalhaoKml={setTalhaoKml}
            open_loading_analise_lab={open_loading_analise_lab}
            grupoAnalises={grupoAnalises}
            tipo_analise_selecionada={tipo_analise_selecionada}
            setTipo_analise_selecionada={setTipo_analise_selecionada}
            tipo_analise_selecionada_id={tipo_analise_selecionada_id}
            setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
            pontos_selecionados={pontos_selecionados}
            setPontos_selecionados={setPontos_selecionados}
            pontos_selecionados_adicionados={pontos_selecionados_adicionados}
            setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
            analises={analises}
            setAnalises={setAnalises}
            pontosTotalMalha={pontosTotalMalha}
            setPontosTotalMalha={setPontosTotalMalha}
            amostra={area_amostra_laudo}
            propriedade_area={area_propriedade}
          />
        </div>
      </DrawerCustom>

      {/* Drawer de Impressão */}
      <Drawer
        destroyOnClose
        width='820px'
        open={modalPrint}
        closeIcon={false}
        onClose={() => {
          setModalPrint(false)
          setDataPrint(null)
          setDataFinish(null)
        }}
        footer={
          <ReactToPrint
            trigger={() => (
              <Button type='primary' title='Imprimir' icon={<PrinterOutlined />}>
                Imprimir
              </Button>
            )}
            content={() => printRef.current}
            onBeforePrint={() => {
              document.title = `${dataPrint?.dataColeta}_${dataPrint?.nome_cliente}_${dataPrint?.talhaoNome}_${dataPrint?.propriedadeNome}`
            }}
            onAfterPrint={() => {
              document.title = 'ttivos - gestão rural'
            }}
          />
        }
      >
        <div ref={printRef}>
          {dataPrint && dataFinish && (
            <Print
              dados={dataFinish}
              data={dataPrint}
              propriedade={dataPropriedades?.find((p) => p?.cod === propriedade_id) ?? ({} as any)}
              areaTalhao={Number(dataTalhoes?.find((t) => t?.nome === talhao)?.area) || 0}
              qtdaPontos={malha?.length ?? malha?.features?.length ?? 0}
            />
          )}
        </div>
      </Drawer>
    </>
  )
}